import React from "react"

export default function wrapper({ children }) {
  return <div>{children}</div>
}
